import React from "react";
import { fmtKop } from "../../utils/format";
import styles from "./MonthlyRevenueTable.module.css";

// products: [{key,title}], months: [{month,name,total_kop,by_product:{key:kop}}]
export default function MonthlyRevenueTable({ products, months, onPickMonth, selected }) {
  if (!months || months.length === 0) return <div className={styles.empty}>Нет данных.</div>;

  const totalsByProduct = {};
  products.forEach((p) => {
    totalsByProduct[p.key] = months.reduce((s, m) => s + (m.by_product[p.key] || 0), 0);
  });
  const grandTotal = months.reduce((s, m) => s + m.total_kop, 0);

  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Месяц</th>
            {products.map((p) => (
              <th key={p.key} className={styles.num}>{p.title}</th>
            ))}
            <th className={styles.num}>Итого</th>
          </tr>
        </thead>
        <tbody>
          {months.map((m) => {
            const isSel = selected && m.month.slice(0, 7) === selected;
            const empty = m.total_kop === 0;
            return (
              <tr
                key={m.month}
                className={`${isSel ? styles.selected : ""} ${empty ? styles.future : ""}`}
                onClick={() => onPickMonth && onPickMonth(m.month)}
              >
                <td className={styles.label}>{m.name}</td>
                {products.map((p) => (
                  <td key={p.key} className={styles.num}>
                    {m.by_product[p.key] ? fmtKop(m.by_product[p.key], { short: true }) : "—"}
                  </td>
                ))}
                <td className={`${styles.num} ${styles.total}`}>
                  {m.total_kop ? fmtKop(m.total_kop, { short: true }) : "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className={styles.label}>Всего</td>
            {products.map((p) => (
              <td key={p.key} className={styles.num}>{fmtKop(totalsByProduct[p.key], { short: true })}</td>
            ))}
            <td className={`${styles.num} ${styles.total}`}>{fmtKop(grandTotal, { short: true })}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
